<script>
import {
  ArrowUpIcon,
} from "vue-feather-icons";
import appConfig from "@/app.config";
import axios from 'axios';
import { EventBus } from "@/event-bus";

// 초기세팅
function initialState() {
  return {
    token: "",
    login: {
      idx: 0,
      level: 0,
      nick: "",
      isLogin: false,
    },
    fields: [
      {key: 'mb_id', label: '아이디', thClass: 'col-1 text-center font-size-11', tdClass: 'col-1 text-center'},
      {key: 'mb_nick', label: '글쓴이명', thClass: 'text-center font-size-11', tdClass: 'col-1 text-center'},
      {key: 'mb_name', label: '별명또는실명', thClass: 'col-1 text-center font-size-11', tdClass: 'col-2 text-center'},
      {key: 'insert_time', label: '가입일', thClass: 'col-2 text-center font-size-11', tdClass: 'col-2 text-center'},
      {key: 'last_time', label: '마지막 접속시간', thClass: 'col-2 text-center font-size-11', tdClass: 'col-2 text-center'},
      {key: 'client_ip', label: '마지막 접속ip', thClass: 'col-2 text-center font-size-11', tdClass: 'col-2 text-center'},
      {key: 'btn', label: '권한', thClass: 'col-2 text-center font-size-11', tdClass: 'text-center'},
    ],
    adminlist: [],
  };
}

export default {
  components: {
    ArrowUpIcon,
  },
  data() {
    return initialState();
  },
  props: {
    selectedMenu: {
      type: String,
    },
  },
  computed: {
  },
  mounted() {
  },
  created() {
    this.first()
    EventBus.$on("admin-list", (val)=> {
      if (val=='listRefresh') {
        this.readAdminList();
      }
    });
  },
  methods: {
    first() {
      let getLocalStorage = JSON.parse(localStorage.getItem('user'))
      if (getLocalStorage) {
        this.login.idx = getLocalStorage.idx
        this.login.nick = getLocalStorage.nick
        this.login.level = getLocalStorage.level
        this.token = getLocalStorage.token
        // 레벨 98 이하거나 로그인 안한상태면 첫화면으로
        if (this.login.level < 98) {
          this.$notify({ type: 'error', duration: 2000, title: '실패', text: '관리자 권한이 없습니다.' })
          this.$router.push('/');
        } else {
          this.readAdminList()
        }
      } else {
        this.$notify({ type: 'error', duration: 2000, title: '실패', text: '관리자 권한이 없습니다.' })
        this.$router.push('/');
      }
    },
    readAdminList() {
      try {
        axios({
          method: 'POST',
          url: appConfig.fastapi + '/auth/admin_read_adminlist',
          headers: {
            'access-token': this.token
          },
          data: {
            "mb_id": this.login.idx,
          },
        })
        .then((res) => {
          if (res.data.type == 'success') {
            this.adminlist = res.data.adminlist;
          }
        })
        .catch((error) => {
          console.log(error)
          if (error.response) {
            this.$notify({ type: 'error', duration: 3000, 'title': error.response.status+' 에러', text: error.response.data.detail })
          }
        })
      } catch (error) {
        this.$notify({ type: 'error', duration: 3000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
      }
    },
    adminChangeLv(val1) {
      // 레벨 99이상만 가능
      if (this.login.level == 99) {
        // 모달 열자
        this.$store.commit('setModal_mdVal', val1); // store.js 로 보내주자
        this.$store.commit('setModal_mdWorker', 'adminChangeLv'); // store.js 로 보내주자
        this.$root.$emit('bv::toggle::modal', 'modal_md'); // 모달 오픈
      } else {
        this.$notify({ type: 'error', duration: 2000, title: '실패', text: '최고관리자만 권한변경가능합니다.' })
      }
    }
  },
}
</script>

<template>
  <div v-show="adminlist" class="rounded shadow">
    <div class="p-4 border-bottom">
      <h5 class="text-md-left text-center">관리 계정</h5>
      <div>
        <div class="row mt-4">

          <div class="col-12 pt-2">
            <div class="rounded shadow">

              <div class="">
                <div class="table table-sm table-responsive font-size-14">
                  <b-table 
                    id="cordingHistoryTable" 
                    ref="cordingHistoryTable" 
                    :fields="fields" 
                    :items="adminlist" 
                    :hover="true"
                    table-class="text-center">
                    <!-- 이메일 -->
                    <template #cell(mb_name)="row">
                      <div class="badge text-secondary bg-white font-size-10">
                        {{ row.item.mb_name }}
                      </div>
                    </template>
                    <!-- 아이디 -->
                    <template #cell(mb_id)="row">
                      <div class="badge text-secondary bg-white font-size-10">
                        {{ row.item.mb_id }}
                      </div>
                    </template>
                    <!-- 닉네임 -->
                    <template #cell(mb_nick)="row">
                      <div class="badge text-dark bg-white font-size-11">
                        {{ row.item.mb_nick }}<i class="mdi mdi-heart text-danger"></i>
                      </div>
                    </template>
                    <!-- 가입일 -->
                    <template #cell(insert_time)="row">
                      <div class="badge text-secondary bg-white font-size-10">
                        {{ row.item.insert_time }}
                      </div>
                    </template>
                    <!-- 마지막 접속시간 -->
                    <template #cell(last_time)="row">
                      <div class="badge text-secondary bg-white font-size-10">
                        {{ row.item.last_time }}
                      </div>
                    </template>
                    <!-- 마지막 접속ip -->
                    <template #cell(client_ip)="row">
                      <div class="badge text-secondary bg-white font-size-10">
                        {{ row.item.client_ip }}
                      </div>
                    </template>
                    <!-- 권한 -->
                    <template #cell(btn)="row">
                      <div class="">
                        <span v-if="row.item.level == 0">
                          <button @click="adminChangeLv(row.item)" class="btn btn-sm btn-soft-warning font-size-11">승인 대기중</button>
                        </span>
                        <span v-else-if="row.item.level == 99 && row.item.mb_id=='korezn'">
                          <button @click="adminChangeLv(row.item)" class="btn btn-sm btn-soft-primary font-size-11">개발자</button>
                        </span>
                        <span v-else-if="row.item.level == 99 && row.item.mb_nick!='정연'">
                          <button @click="adminChangeLv(row.item)" class="btn btn-sm btn-soft-primary font-size-11">최고 관리자</button>
                        </span>
                        <span v-else-if="row.item.level == 98">
                          <button @click="adminChangeLv(row.item)" class="btn btn-sm btn-soft-blue font-size-11">일반 관리자</button>
                        </span>
                        <span @click="adminChangeLv(row.item)" v-else>
                          <button class="btn btn-sm btn-soft-primary font-size-11">일반 회원</button>
                        </span>
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>